module.exports = __webpack_public_path__ + "img/article_7_3.6607b6c2.png";